import axios from "axios";
import React, { Component, useState, useEffect, useContext, lazy, Suspense } from "react";
import queryString from "query-string";
import { Helmet } from "react-helmet";
import Swal from "sweetalert2";
import { FaRegClock } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { alert_error, alert_success } from "../../AppContext";
import Login_google from '../../auth/login_google_main';
import { Cookies } from '../../index.js';
import { ClipLoader } from "react-spinners";
const LazyReCAPTCHA = lazy(() => import("../../app_structure/LazyReCAPTCHA"));
function Capdo3(props) {
  const capdo3 = props.data;
  const [isLoading, setIsLoading] = useState(false);
  const [lienketjop, setlienketjop] = useState("");
  const [disabledbutton, setdisabledbutton] = useState(false);
  // Gọi hàm alert_error
  const [showquangcao, setshowquangcao] = useState(false);
  const [idlink, setidlink] = useState('');
  const [taskId, settaskId] = useState('');
  const [lienket, setLienket] = useState("");
  const recaptchaRef = React.createRef();
  const [nutxuly, setnutxuly] = useState("");

  const [buttonTextjop, setButtontextjop] = useState("Thả tim xong ấn đây để kiểm tra nhé");
  const [loading, setLoading] = useState(false);
  const [api_key, setapi_key] = useState("");
  const [lienketok, setlienketok] = useState("");
  const [code3, setcode3] = useState("");
  const navigate = useNavigate();
  const handleClick = async () => {
    startcheck();
    setTimeout(function () {
      window.open(lienketjop, '_blank');
    }, 500);
  };
  const startcheck = async () => {
    let data = JSON.stringify({
      "idlink": idlink,
      "taskId": taskId,
      "username": "hustmedia1",
      "chedo": 'tiktoklike'
    });
    setIsLoading(1);
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://hust.media/jop/startcheck.php',
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    };

    axios.post(config.url, config.data, config.headers)
      .then((response) => {
        console.log(JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log(error);
      });

  };
  useEffect(() => {
    laydulieujop();
  }, []);

  function laydulieujop() {

    const fetchLienketjop = async () => {
      try {
        const response = await axios.get('https://hust.media/jop/getjopurl.php');
        setlienketjop(response.data.urlok);
        setidlink(response.data.idlink);
        settaskId(response.data.taskId);
        setcode3(response.data.code3);
        setLoading(true);
      } catch (error) {
        alert_error('Lỗi xảy ra vui lòng load lại');
      }

    };
    fetchLienketjop();
  };

  const checktim = async () => {
    setshowquangcao(1);
    const hustmediavipro = Cookies.get('hustmediavipro');
    setButtontextjop("Please wait a moment 😊");
    let data = JSON.stringify({
      "idlinka": idlink,
      "idzad": taskId,
      "idclana": code3,
      "url": lienketjop,
      "username": "hustmedia1",
      "chedo": 'tiktoklike',
      "lienket": hustmediavipro
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://hust.media/link/checktiktok.php',
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    };

    axios.post(config.url, config.data, config.headers)
      .then((response) => {
        if (response.data.status == 1) {
          setnutxuly(0);
          const lienketjop = response.data.order;
          console.log(lienketjop);
          props.onLienKetChange(lienketjop); // gọi hàm từ props để cập nhật liên kết trong component cha
          alert_success('Xác thực thành công');
          setdisabledbutton(true);
          setButtontextjop("Hust Media cảm ơn bạn đã ghé thăm");
        }
        else if (response.data.status == 7) {
          setnutxuly(0);
          Cookies.set('capdovuotlink', 2, { expires: 1 / 12 }); // gọi hàm từ props để cập nhật liên kết trong component cha
          alert_success('Còn 1 bước nữa là đến liên kết');
          setButtontextjop("Xác thực thành công");
          setTimeout(() => {
            navigate('/home2/');
          }, 1200);
        }
        else {
          setButtontextjop("Vượt link thất bại");
          alert_error('Vượt link thất bại');
        }
        console.log(response.data.status)


        setButtontextjop("checktim");
      })
      .catch((error) => {
        alert_error(error);
      });

  };




  return (
    <div>
      {showquangcao == 1 &&
        <Helmet>
          {/* <script async="async" data-cfasync="false" src="//ophoacit.com/1?z=5904788"></script> */}
        </Helmet>}
      <div className="form-control">
        <div style={{ textAlign: "center" }} className="mt-0   justify-center items-center ">
          {loading == false ? (<> <div> <div className="spinner-border text-primary" role="status"></div>
            <span  >Đang tải dữ liệu</span>
          </div></>) : loading == true && (<>
            <button disabled={disabledbutton}
              className="py-3 px-6 text-lg font-bold text-white bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-700 hover:to-blue-900 rounded-lg shadow-md"
              onClick={handleClick}
            >
              Thả tim video TikTok để xác thực bạn không phải người máy
            </button>
            {
              isLoading == 1 && (
                <>
                  <button disabled={disabledbutton}
                    className="py-3 px-6 text-lg font-bold text-white bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-700 hover:to-blue-900 rounded-lg shadow-md"
                    onClick={checktim}
                  >
                    {buttonTextjop != "Please wait a moment 😊" ? (
                      <span>{buttonTextjop}</span>
                    ) : (
                      <><svg aria-hidden="true" role="status" className="inline w-6 h-6 mr-2 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB" />
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                      </svg>
                        {buttonTextjop}
                         </>)}
                  </button> </>
              )
            }
          </>)}


        </div></div>
      <div id="container-29c4d94d70c70c3f8264cc0b965393ba"></div>
    </div>
  );
}

export default Capdo3;
